'use client';

import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form';

import DatePicker from '@/components/forms/DatePicker/DatePicker';

type DatePickerFieldProps<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  placeholder?: string;
  required?: boolean;
  control: Control<T>;
  error?: string;
  colSpan?: 1 | 2;
  allowFutureDates?: boolean;
};

export function DatePickerField<T extends FieldValues>({
  name,
  label,
  placeholder,
  required,
  control,
  error,
  allowFutureDates,
}: DatePickerFieldProps<T>) {
  const fieldId = `field-${String(name).replace(/[^a-zA-Z0-9_-]/g, '-')}`;
  return (
    <div className="flex flex-col gap-1">
      <span className="flex items-center">
        <label
          htmlFor={fieldId}
          className="text-royal-500 text-xs font-semibold"
        >
          {label}
        </label>
        {required && (
          <span className="ml-1 text-xs font-semibold text-red-500">*</span>
        )}
      </span>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            id={fieldId}
            value={field.value ?? ''}
            onChange={field.onChange}
            onBlur={field.onBlur}
            placeholder={placeholder}
            allowFutureDates={allowFutureDates}
          />
        )}
      />
      {error && (
        <span role="alert" className="mt-0.5 text-[10px] text-red-500">
          {error}
        </span>
      )}
    </div>
  );
}
